module.exports = __webpack_public_path__ + "static/the-conquest-of-gaul-17021ae30fcfdf6bd040b2a4f749450f.jpg";